import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_V_L, TS_Input, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { thunderstormCapabilitiesGroup } from '@nu-art/thunderstorm-frontend/consts';
import { PageStateManager } from '../../_modules/ModuleFE_AppState.js';
import { md5 } from '@nu-art/ts-common';
const manager = new PageStateManager(`/app-tools/${md5('App State')}`);
class ATS_AppState_Class extends ComponentSync {
    deriveStateFromProps(p, state) {
        state.value_Input ??= manager.value.get('value_Input');
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { children: [_jsx(TS_PropRenderer.Horizontal, { label: 'Input', children: _jsx(TS_Input, { type: 'text', value: this.state.value_Input, onChange: val => {
                            this.setState({ value_Input: val }, () => manager.value.set('value_Input', val));
                        } }) }), _jsx(Button, { variant: 'primary', onClick: () => manager.getExportURL(), children: "Export State" })] });
    }
}
export const ATS_AppState = {
    key: 'ats-app-state',
    name: 'App State',
    renderer: ATS_AppState_Class,
    group: thunderstormCapabilitiesGroup,
};
//# sourceMappingURL=ATS_AppState.js.map